import { Search } from '@carbon/react';
import type { ComponentProps } from 'react';
import { cx } from '../../utils';
import styles from './CdSearchField.module.scss';

type CarbonSearchProps = ComponentProps<typeof Search>;

export interface CdSearchFieldProps extends Omit<
  CarbonSearchProps,
  'onChange' | 'labelText' | 'size'
> {
  /** Accessible label (visually hidden, Carbon convention). */
  label: string;
  value?: string;
  onValueChange?: (value: string) => void;
  size?: 'sm' | 'md' | 'lg';
  /** `field` = white field on grey canvas (Figma index page); `layer` = grey field on white. */
  appearance?: 'field' | 'layer';
}

export const CdSearchField = ({
  label,
  onValueChange,
  size = 'md',
  appearance = 'field',
  className,
  ...rest
}: CdSearchFieldProps) => {
  return (
    <Search
      labelText={label}
      size={size}
      closeButtonLabelText="Clear search"
      className={cx(styles[appearance], className)}
      onChange={(event) => onValueChange?.(event.target.value)}
      {...rest}
    />
  );
};
